import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COLORS = ["#FF007F", "#B200FF", "#00F0FF", "#FF6000", "#7000FF"];

export default function CaseStudies() {
  const [list, setList] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    axios.get(`${API}/case-studies`).then((r) => setList(r.data)).catch(() => {});
  }, []);

  const cur = list[active];

  return (
    <section id="cases" className="relative py-28 px-6" data-testid="case-studies-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="font-mono text-[11px] tracking-[0.4em] text-cyan-300/80 mb-3">◆ CASE STUDIES · ORBIT</p>
          <h2 className="text-4xl sm:text-5xl font-[Outfit] font-bold">Each client is a <span className="text-gradient">planet.</span></h2>
          <p className="mt-3 text-white/65 max-w-2xl mx-auto">Click a world to enter its growth story.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Orbit Visual */}
          <div className="relative h-[480px] rounded-3xl glass holo-border overflow-hidden grid-bg">
            <div className="absolute inset-0 grid place-items-center">
              {/* Center star */}
              <div className="absolute w-20 h-20 rounded-full" style={{ background: "radial-gradient(circle, #FFB400, #FF6000 60%, transparent)", boxShadow: "0 0 60px #FF6000aa, 0 0 24px #FFB400" }} />
              {/* Orbits */}
              {[160, 210, 260].map((r) => (
                <div key={`orbit-${r}`} className="absolute rounded-full border border-white/10" style={{ width: r * 2, height: r * 2 }} />
              ))}
              {/* Planets */}
              {list.map((c, i) => {
                const angle = (i / Math.max(list.length, 1)) * Math.PI * 2;
                const radius = 160 + (i % 3) * 50;
                const x = Math.cos(angle) * radius;
                const y = Math.sin(angle) * radius;
                const color = COLORS[i % COLORS.length];
                const isActive = active === i;
                return (
                  <button
                    key={c.id}
                    onClick={() => setActive(i)}
                    data-testid={`planet-${c.id}`}
                    className={`absolute transition-transform ${isActive ? "scale-125" : "hover:scale-110"}`}
                    style={{ transform: `translate(${x}px, ${y}px)` }}
                  >
                    <div
                      className="w-12 h-12 rounded-full animate-pulse-glow"
                      style={{
                        background: `radial-gradient(circle at 30% 30%, ${color}, #050816 80%)`,
                        boxShadow: `0 0 24px ${color}aa, inset 0 0 12px ${color}77`,
                      }}
                    />
                    <div className="mt-1 font-mono text-[10px] text-white/70 text-center">{c.client.split(" ")[0]}</div>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Detail Panel */}
          <div className="glass holo-border rounded-3xl p-7" data-testid="case-detail">
            {cur ? (
              <>
                <div className="font-mono text-[10px] uppercase tracking-widest text-cyan-300/80">{cur.industry}</div>
                <h3 className="mt-1 text-3xl font-[Outfit] font-bold">{cur.client}</h3>
                <div className="mt-4 grid grid-cols-2 gap-3">
                  <div className="glass rounded-xl p-3">
                    <div className="text-[10px] font-mono uppercase text-white/45">Growth</div>
                    <div className="text-xl font-[Outfit] font-bold text-gradient-cyan">{cur.growth}</div>
                  </div>
                  <div className="glass rounded-xl p-3">
                    <div className="text-[10px] font-mono uppercase text-white/45">ROI</div>
                    <div className="text-xl font-[Outfit] font-bold text-gradient">{cur.roi}</div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="text-[10px] font-mono uppercase text-white/45">Problem</div>
                  <p className="mt-1 text-white/80 text-sm">{cur.problem}</p>
                </div>
                <div className="mt-4">
                  <div className="text-[10px] font-mono uppercase text-white/45">MUNNEXA Solution</div>
                  <p className="mt-1 text-white/80 text-sm">{cur.solution}</p>
                </div>
                <button onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })} data-testid="case-cta" className="mt-6 btn-ghost rounded-full px-5 py-2.5 text-sm">
                  Engineer my growth →
                </button>
              </>
            ) : (
              <div className="text-white/50">Loading orbit…</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
